module.exports = __webpack_public_path__ + "img/status-eveywhere.a4d2d4fd.png";